export default "__VITE_ASSET__CnWnv1Ix__"